import { type RoleTypeEnum } from '../enums/RoleTypeEnum'
import { type UserTierEnum } from '../enums/UserTierEnum'
import { Permission, type PermissionConstructor } from '../Permission'

export interface RoleConstructor {
  id: number
  name: string
  type: RoleTypeEnum
  permissions: PermissionConstructor[]
  userCount: number
  tier?: UserTierEnum
}

export class Role {
  id: number
  name: string
  type: RoleTypeEnum
  permissions: Permission[]
  userCount: number
  tier?: UserTierEnum

  constructor(data: RoleConstructor) {
    this.id = data.id
    this.name = data.name
    this.type = data.type
    this.permissions = data.permissions.map((p) => new Permission(p))
    this.userCount = data.userCount

    if (data.tier) {
      this.tier = data.tier
    }
  }
}
